export default __webpack_public_path__ + "static/media/sidenav_icon.c0ddb050.svg";